import {Module} from "vuex";

import {RootStateType} from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import {DataImplementationsWithMessagesCountState} from "./model";

let state: DataImplementationsWithMessagesCountState = {
  dataImplementationsWithMessagesCounts: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<DataImplementationsWithMessagesCountState, RootStateType>;
